
import moment from 'moment'

export default {

  methods: {

    toDateTimeBr(value) {

      if (value == null) {
        return ''
      }

      return moment(value, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY HH:mm')
    }
  }
}